import type { RentalManagerAuthCheckUserInfoFeaturesWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';
import type { Props as HeaderNavigationProps } from '../components/HeaderNavigation';

type Props = Partial<HeaderNavigationProps>;

export const getNavDisplays = (props: Props) => {
  const { userModel: { features = {}, isEnterpriseCustomer = false, isSelfServeCustomer = false } = {} } = props;

  const {
    displayAccessMainContactSupport,
    displayAdManagement,
    displayAnalytics,
    displayBilling,
    displayMainBanking,
    displayMFHResources,
    displayMainAccountSettings,
    displayMainBilling,
    displayMainDashboard,
    displayMainHelp,
    displayMainLeadManagement,
    displayMainLeads,
    displayMainMaintenanceTracker,
    displayMainMessages,
    displayMainMyProperties,
    displayMainNotificationCenter,
    displayMainResources,
    displayMainSecuritySettings,
    displayOnboardingTasks,
    displayUserManagement,
  } = props;

  const {
    canAccessBilling,
    canAccessMainAccountSettings,
    canAccessMainAnalytics,
    canAccessMainBanking,
    canAccessMainBilling,
    canAccessMainContactSupport,
    canAccessMainContacts,
    canAccessMainHelp,
    canAccessMainLeadManagement,
    canAccessMainMaintenanceTracker: aCanAccessMainMaintenanceTracker,
    canAccessMainMessages,
    canAccessMainMyProperties,
    canAccessMainNotificationCenter,
    canAccessMainPayments,
    canAccessMainResources,
    canAccessMainSecuritySettings,
    canAccessMultiFamilyResources,
    canAccessUserManagement,
    canAccessZillowAccountSettings,
  } = features as RentalManagerAuthCheckUserInfoFeaturesWebApiDto;

  const canAccessMainMaintenanceTracker = aCanAccessMainMaintenanceTracker && isEnterpriseCustomer === false;

  const displays = {
    displayAccessMainContactSupport: canAccessMainContactSupport || displayAccessMainContactSupport,
    displayAdManagement: isSelfServeCustomer || displayAdManagement,
    displayAnalytics: canAccessMainAnalytics || displayAnalytics,
    displayBilling: canAccessBilling || displayBilling,
    displayMFHResources: canAccessMultiFamilyResources || displayMFHResources,
    displayMainAccountSettings: canAccessMainAccountSettings || displayMainAccountSettings,
    displayMainBilling: canAccessMainBilling || displayMainBilling,
    displayMainDashboard,
    displayMainHelp: canAccessMainHelp || displayMainHelp,
    displayMainLeadManagement: canAccessMainLeadManagement || displayMainLeadManagement,
    displayMainLeads: canAccessMainContacts || displayMainLeads,
    displayMainMaintenanceTracker: canAccessMainMaintenanceTracker || displayMainMaintenanceTracker,
    displayMainMessages: canAccessMainMessages || displayMainMessages,
    displayMainMyProperties: canAccessMainMyProperties || displayMainMyProperties,
    displayMainBanking: canAccessMainBanking || displayMainBanking,
    displayMainNotificationCenter: canAccessMainNotificationCenter || displayMainNotificationCenter,
    displayMainPayments: canAccessMainPayments,
    displayMainResources: canAccessMainResources || displayMainResources,
    displayMainSecuritySettings: canAccessMainSecuritySettings || displayMainSecuritySettings,
    displayOnboardingTasks: isSelfServeCustomer || displayOnboardingTasks,
    displayUserManagement: canAccessUserManagement || displayUserManagement,
    displayZillowAccountSettings: canAccessZillowAccountSettings,
  };

  return {
    displays,
  };
};

export const getPaymentsPath = ({
  paymentsAcceptedCount,
  paymentsGetStartedPage,
  rentPaymentPage,
  paymentsAggregatePage,
}: {
  paymentsAcceptedCount: number;
  paymentsGetStartedPage: string;
  rentPaymentPage: string;
  paymentsAggregatePage: string;
}) => {
  if (paymentsAcceptedCount === 0) {
    return paymentsGetStartedPage;
  }
  if (paymentsAcceptedCount === 1) {
    return rentPaymentPage;
  } else return paymentsAggregatePage;
};
